import { render, staticRenderFns } from "./Step_0.vue?vue&type=template&id=a5214074&"
import script from "./Step_0.vue?vue&type=script&lang=js&"
export * from "./Step_0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports